<app-side-menu>
  <div class="budget-proposals-content">
    <app-controladoria-nav></app-controladoria-nav>

    <header class="bp-header">
      <div>
        <h1 class="bp-title">
          <i class="fas fa-file-invoice-dollar me-2"></i>
          Propostas de orçamento
        </h1>
        <p class="bp-subtitle text-muted mb-0">
          O colaborador indica a verba que considera adequada para o centro de custo vinculado.
          A controladoria analisa e aprova conforme o fluxo interno.
        </p>
      </div>
    </header>

    <div class="filters-section mb-4">
      <div class="filters-row">
        <div class="filter-group">
          <label class="form-label" for="statusFilter">Status</label>
          <select
            id="statusFilter"
            class="form-select"
            [(ngModel)]="statusFilter"
            (change)="applyFilters()">
            <option *ngFor="let o of statusOptions" [value]="o.value">{{ o.label }}</option>
          </select>
        </div>
        <div class="filter-actions align-self-end">
          <button type="button" class="btn btn-outline-secondary" (click)="clearFilters()">
            <i class="fas fa-times me-2"></i>
            Limpar
          </button>
        </div>
      </div>
    </div>

    <div class="bp-card">
      <div *ngIf="!isLoading && rows.length === 0" class="empty-state text-center py-5">
        <i class="fas fa-file-invoice-dollar fa-3x text-muted mb-3"></i>
        <h3>Nenhuma proposta encontrada</h3>
        <p class="text-muted">Registre a primeira indicação de orçamento para um centro de custo.</p>
      </div>

      <app-table
        *ngIf="rows.length > 0 || isLoading"
        [title]="tableTitle"
        [data]="rows"
        [columns]="columns"
        [loading]="isLoading"
        [showSearch]="false"
        [clickable]="true"
        [actions]="actions"
        [enableSorting]="true"
        [clientSideSort]="true"
        [disablePagination]="false"
        [totalItemsFromBackend]="totalItems"
        [currentPageFromBackend]="page"
        [totalPagesFromBackend]="totalPages"
        (rowClick)="onRowClick($event)"
        (actionClick)="onActionClick($event)"
        (pageChange)="onPageChange($event)">
        <div table-header-action class="d-flex gap-2">
          <button
            type="button"
            class="btn btn-outline-success btn-sm"
            [disabled]="isExporting || isLoading"
            (click)="exportToExcel()">
            <i class="fas fa-file-excel me-1" [class.fa-spin]="isExporting"></i>
            Exportar Excel
          </button>
          <button
            type="button"
            class="btn btn-primary btn-sm"
            *appHasPermission="'CostCenters.View'"
            (click)="openCreateModal()">
            <i class="fas fa-plus me-1"></i>
            Nova proposta
          </button>
        </div>
      </app-table>
    </div>
  </div>

  <app-modal
    [isOpen]="showCreateModal"
    [title]="'Nova proposta de orçamento'"
    [size]="'lg'"
    [closable]="!isSubmitting"
    (close)="closeCreateModal()">
    <p class="text-muted small">
      Informe o centro de custo e os valores que você considera adequados. Preencha os campos conforme a necessidade do seu setor.
    </p>
    <div class="row g-3">
      <div class="col-12">
        <label class="form-label">Centro de custo <span class="text-danger">*</span></label>
        <select class="form-select" [(ngModel)]="form.costCenterId" [disabled]="isSubmitting">
          <option [ngValue]="null">Selecione...</option>
          <option *ngFor="let cc of costCenters" [ngValue]="cc.id">
            {{ cc.code }} — {{ cc.name }}
          </option>
        </select>
      </div>
      <div class="col-md-6">
        <label class="form-label">Orçamento mensal proposto <span class="text-danger">*</span></label>
        <input
          type="number"
          class="form-control"
          [(ngModel)]="form.proposedMonthlyBudget"
          (ngModelChange)="onMonthlyBudgetChange()"
          [disabled]="isSubmitting"
          min="0"
          step="0.01"
          placeholder="Informe o valor mensal" />
      </div>
      <div class="col-md-6">
        <label class="form-label">Orçamento anual proposto <span class="text-danger">*</span></label>
        <input
          type="number"
          class="form-control"
          [(ngModel)]="form.proposedAnnualBudget"
          [disabled]="isSubmitting"
          min="0"
          step="0.01"
          placeholder="Informe o valor anual" />
        <small class="text-muted">Pode ser ajustado manualmente (sugestão: mensal × 12).</small>
      </div>
      <div class="col-12">
        <label class="form-label">Justificativa <span class="text-danger">*</span></label>
        <textarea
          class="form-control"
          rows="4"
          [(ngModel)]="form.justification"
          [disabled]="isSubmitting"
          maxlength="2000"
          placeholder="Descreva o motivo da indicação de verba"></textarea>
      </div>
    </div>
    <div slot="footer" class="d-flex justify-content-end gap-2">
      <button type="button" class="btn btn-outline-secondary" [disabled]="isSubmitting" (click)="closeCreateModal()">
        Cancelar
      </button>
      <button type="button" class="btn btn-primary" [disabled]="!canSubmit() || isSubmitting" (click)="submitProposal()">
        <i class="fas fa-spinner fa-spin me-1" *ngIf="isSubmitting"></i>
        Enviar proposta
      </button>
    </div>
  </app-modal>
</app-side-menu>
